// 🟦 SignUp.jsx
// This screen lets a new user register an account.

import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../../services/apiService";
import { useAuthStore } from "../../store/useAuthStore";
import { logger } from "../../utils/logger";
import "./auth.css";

logger.log("📂 [SignUp.jsx] File started");

const Signup = () => {
  logger.log("➡️ [Signup] Component mounted");

  const navigate = useNavigate();
  const { setUser, setLoading, setError, error, init } = useAuthStore();
  const [form, setForm] = useState({ firstName: "", lastName: "", email: "", password: "" });

  useEffect(() => {
    logger.log("🧠 [Signup] useEffect init()");
    init();
  }, [init]);

  const onChange = (e) => {
    logger.log("✏️ [Signup] Updating form field", { field: e.target.name });
    setForm((s) => ({ ...s, [e.target.name]: e.target.value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    logger.log("➡️ [Signup] onSubmit start");
    setLoading(true);
    setError(null);
    try {
      const profile = await api.request("/auth/signup", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      logger.log("✅ [Signup] Signup success", profile);
      setUser(profile);
      navigate("/dashboard");
    } catch (err) {
      logger.error("❌ [Signup] Signup failed", err);
      setError(err.message || "Signup failed");
    } finally {
      setLoading(false);
      logger.log("⬅️ [Signup] onSubmit end");
    }
  };

  logger.log("✅ [Signup] Component rendered");
  return (
    <div className="auth-wrap">
      <h1 className="auth-title">Create your account</h1>
      <p className="auth-sub">Sign up to manage your apps</p>

      <form onSubmit={onSubmit}>
        <div className="auth-row">
          <div className="auth-field" style={{ flex: 1 }}>
            <label>First name</label>
            <input name="firstName" value={form.firstName} onChange={onChange} placeholder="Jane" />
          </div>
          <div className="auth-field" style={{ flex: 1 }}>
            <label>Last name</label>
            <input name="lastName" value={form.lastName} onChange={onChange} placeholder="Doe" />
          </div>
        </div>

        <div className="auth-field">
          <label>Email</label>
          <input name="email" type="email" value={form.email} onChange={onChange} placeholder="you@example.com" />
        </div>

        <div className="auth-field">
          <label>Password</label>
          <input name="password" type="password" value={form.password} onChange={onChange} placeholder="••••••••" />
        </div>

        <div className="auth-actions">
          <button type="submit" className="btn-primary">Create account</button>
        </div>
      </form>

      {error && <div className="auth-error">{error}</div>}

      <p className="auth-note" style={{ marginTop: 16 }}>
        Already have an account? <Link to="/signin">Sign in</Link>
      </p>
    </div>
  );
};

logger.log("✅ [SignUp.jsx] File executed successfully");
export default Signup;
